import { useState } from "react";
import {
  PlansApi,
  RequestUpdatePlanRequest,
  PlansUpdateBoxInfoPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpdateShipment = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const updateShipment = async (req: RequestUpdatePlanRequest) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: PlansUpdateBoxInfoPostRequest = {
        req,
      };

      const api = new PlansApi(config);
      const response = await api.plansUpdateBoxInfoPost(request);
      setResult(response);
      return response;
    } catch (err) {
      setError("更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { updateShipment, error, isLoading };
};
